import { Button, Dialog, DialogActions, DialogContent } from '@mui/material'
import { DefaultDialogTitle } from 'components/styled/Dialog'
import React from 'react'
import i18n from 'simple-react-i18n'
import PropTypes from 'prop-types'
import SimpleSelectionTable from 'components/datatable/SimpleSelectionTable'

const HEADERS_MANAGEMENT_ENTITIES = ['code', 'name', 'email']

const DialogManagementUnits = ({
    open= false,
    onClose = () => {},
    onValidate = () => {},

    managementUnits = [],
    selectedManagementUnits = [],
    setSelectedManagementUnits = () => {},
}) => {
    return (
        <Dialog open={open} maxWidth={'lg'}>
            <DefaultDialogTitle title={i18n.addManagementEntity} onClose={onClose}/>
            <DialogContent>
                <SimpleSelectionTable
                    listHeaders={HEADERS_MANAGEMENT_ENTITIES}
                    listTitle={i18n.listManagementEntities}
                    selectedListTitle={i18n.managementEntitiesSelected}

                    listData={managementUnits}
                    selectedList={selectedManagementUnits}

                    onChange={setSelectedManagementUnits}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>
                    {i18n.close}
                </Button>
                <Button onClick={onValidate} variant='contained' color='primary'>
                    {i18n.validate}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

DialogManagementUnits.propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func.isRequired,
    onValidate: PropTypes.func.isRequired,
    managementUnits: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number.isRequired,
        code: PropTypes.number,
        name: PropTypes.string,
        labelWithCode: PropTypes.string,
        creationDate: PropTypes.number,
        ugeCode: PropTypes.string,
        sispeaCode: PropTypes.string,
        referentCode: PropTypes.number,
        productionSkill: PropTypes.number,
        protectionSkill: PropTypes.number,
        treatmentSkill: PropTypes.number,
        storageSkill: PropTypes.number,
        distributionSkill: PropTypes.number,
        ccspl: PropTypes.bool,
        email: PropTypes.string,
        contactTitle: PropTypes.string,
        contactPhone: PropTypes.string,
        openHours: PropTypes.string,
        headers: PropTypes.arrayOf(PropTypes.string),
    })),
    selectedManagementUnits: PropTypes.arrayOf(PropTypes.number),
    setSelectedManagementUnits: PropTypes.func,
}

export default DialogManagementUnits